import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

import FieldWarning from "../components/FieldWarning";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useEditOutletDetailsMutation } from "../slices/OutletSlice";

const EditOutletScreen = ({ outlet, editable }) => {
  const { userInfo } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  // const [outletId, setOutletId] = useState("");
  const [outletGroup, setOutletGroup] = useState(outlet?.outletGroup);
  // const [companyId, setCompanyId] = useState();
  const [seperateGst, setSeperateGst] = useState(outlet?.separateGst);
  const [outletCategory, setOutletCategory] = useState(outlet?.outletCategory);
  const [outletName, setOutletName] = useState(outlet?.outletName);
  const [outletAddress, setOutletAddress] = useState(outlet?.outletAddress);
  const [outletPincode, setOutletPincode] = useState(outlet?.outletPincode);
  const [outletState, setOutletState] = useState(outlet?.outletState);
  const [outletContact, setOutletContact] = useState(outlet?.outletContact);
  const [addedBy, setAddedBy] = useState(outlet?.addedBy);
  const [operationStatus, setOperationStatus] = useState(
    outlet?.operationStatus
  );
  const [openingHour, setOpeningHour] = useState(outlet?.openingHour);
  const [closingHour, setClosingHour] = useState(outlet?.closingHour);
  const [openedDays, setOpenedDays] = useState(outlet?.openedDays || []);

  const [outletIdPresent, setOutletIdPresent] = useState(false);
  const [outletGroupPresent, setOutletGroupPresent] = useState(false);
  const [companyIdPresent, setCompanyIdPresent] = useState(false);
  const [seperateGstPresent, setSeperateGstPresent] = useState(false);
  const [outletNamePresent, setOutletNamePresent] = useState(false);
  // const [outletCategoryPresent, setOutletCategoryPresent] = useState(false);
  const [outletStatePresent, setOutletStatePresent] = useState(false);
  const [currentlyOpenPresent, setCurrentlyOpenPresent] = useState(false);
  const [outletContactPresent, setOutletContactPresent] = useState(false);
  const [outletAddressPresent, setOutletAddressPresent] = useState(false);
  const [outletPincodePresent, setOutletPincodePresent] = useState(false);

  const sepGst = ["Yes", "No"];
  const openStatus = ["Yes", "No"];
  const outCat = [
    "Select Category",
    "Restaurant",
    "Bakery",
    "Food Truck",
    "Theatre",
    "Bars",
    "Hotel",
    "Company",
    "Transport",
    "Train",
  ];

  const availableStateNames = [
    "Select State",
    "Andhra Pradesh",
    "Karnataka",
    "Kerala",
    "Maharashtra",
    "Tamil Nadu",
    "Telangana",
  ];
  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const handleCheckboxChange = (day) => {
    setOpenedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const [editDetails, { isLoading }] = useEditOutletDetailsMutation();

  useEffect(() => {
    // if (outletId?.length === 3) {
    //   setOutletIdPresent(false);
    // }

    // if (companyId?.length === 4) {
    //   setCompanyIdPresent(false);
    // }

    if (outletName?.trim().length > 0) {
      setOutletNamePresent(false);
    }

    if (outletState !== "Select State") {
      setOutletStatePresent(false);
    }

    if (outletAddress?.length > 10) {
      setOutletAddressPresent(false);
    }

    if (outletPincode?.length === 6) {
      setOutletPincodePresent(false);
    }

    if (outletContact?.length === 10) {
      setOutletContactPresent(false);
    }

    if (operationStatus) {
      setCurrentlyOpenPresent(false);
    }

    if (openedDays.length > 0) {
      setSeperateGstPresent(false);
    }
  }, [
    // outletId,
    // companyId,
    outletName,
    outletState,
    outletAddress,
    seperateGst,
    outletPincode,
    outletContact,
    operationStatus,
    openedDays,
  ]);

  const verifyInputFields = () => {
    let fieldValidationSuccess = true;

    // if (outletId?.length !== 3) {
    //   setOutletIdPresent(true);
    //   fieldValidationSuccess = false;
    // }

    // if (companyId?.length !== 4) {
    //   setCompanyIdPresent(true);
    //   fieldValidationSuccess = false;
    // }

    if (outletName?.trim().length < 1) {
      setOutletNamePresent(true);
      fieldValidationSuccess = false;
    }

    if (outletState === "Select State") {
      setOutletStatePresent(true);
      fieldValidationSuccess = false;
    }

    if (outletAddress?.length < 10) {
      setOutletAddressPresent(true);
      fieldValidationSuccess = false;
    }

    if (outletPincode?.length !== 6) {
      setOutletPincodePresent(true);
      fieldValidationSuccess = false;
    }

    if (outletContact?.length !== 10) {
      setOutletContactPresent(true);
      fieldValidationSuccess = false;
    }

    if (seperateGst !== true && seperateGst !== false) {
      setSeperateGstPresent(true);
      fieldValidationSuccess = false;
    }

    if (!fieldValidationSuccess) {
      toast.error(
        "Some fields have invalid inputs. Please provide valid details."
      );
    }
    return fieldValidationSuccess;
  };

  const submitHandler = async () => {
    if (verifyInputFields()) {
      try {
        const data = {
          outletId: outlet?._id,
          outletGroup: outletGroup,
          separateGst: seperateGst,
          outletCategory: outletCategory,
          outletName: outletName,
          outletAddress: outletAddress,
          outletPincode: outletPincode,
          outletState: outletState,
          outletContact: outletContact,
          addedBy: addedBy,
          operationStatus: operationStatus,
          openingHour: openingHour,
          closingHour: closingHour,
          openedDays: openedDays,
          token: userInfo.token,
        };
        await editDetails(data).unwrap();
        toast.success("Details Updated Successfully");
        editable();
      } catch (e) {
        console.error("Error occurred: ", e);
        // toast.error("Something went Wrong");
      }
    }
  };
  const handleCancel = () => {
    //navigate(-1);
    editable();
  };
  return (
    <>
      <h5> Edit Outlet</h5>
      <Row
        style={{
          display: "flex",
          marginTop: "3rem",
          marginLeft: "15rem",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form>
          {/* <Form.Group as={Row} sm="3">
                  <Form.Label column="true" sm="3">
                    <strong>Outlet Id </strong>{" "}
                  </Form.Label>
                  <Col>
                    <Form.Control
                      type="text"
                      // pattern="[0-9]"
                      value={outletId}
                      onChange={(e) => {
                        const val = e.target.value.replace(/[^0-9]/g, "");
                        setOutletId(val);
                      }}
                      placeholder="Enter Outlet Id"
                    />
                    {outletIdPresent ? (
                      <FieldWarning text="Outlet Id should be 3 chars long" />
                    ) : (
                      ""
                    )}
                  </Col>
                </Form.Group> */}

          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Outlet Name</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={outletName}
                onChange={(e) => setOutletName(e.target.value)}
                placeholder="Enter outlet name"
              />
              {outletNamePresent ? (
                <FieldWarning text="Please enter outlet name" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong> Outlet Address</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={outletAddress}
                onChange={(e) => setOutletAddress(e.target.value)}
                placeholder="Enter address"
              />
              {outletAddressPresent ? (
                <FieldWarning text="Address should be atleast 10 chars long" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Outlet Pincode</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                // pattern="[0-9]"
                value={outletPincode}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setOutletPincode(val);
                }}
                placeholder="Enter Pincode"
              />
              {outletPincodePresent ? (
                <FieldWarning text="Pincode should be 6 chars long" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>State</strong>
              <label style={{ color: "red" }}>*</label> :
            </Form.Label>
            <Col sm="4">
              <Form.Select
                value={outletState}
                onChange={(e) => setOutletState(e.target.value)}
                placeholder="Select State"
              >
                {availableStateNames?.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </Form.Select>
              {outletStatePresent ? (
                <FieldWarning text="Please Select State" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Outlet Contact</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                // pattern="[0-9]"
                value={outletContact}
                onChange={(e) => {
                  const val = e.currentTarget.value.replace(/[^0-9]/g, "");
                  setOutletContact(val);
                }}
              />
              {outletContactPresent ? (
                <FieldWarning text="Contact number should be 10 digits" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>
                {" "}
                In Operation Now ?<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col sm="6">
              <div className="horizontal-radio-group">
                {openStatus?.map((option) => (
                  <Form.Check
                    key={option}
                    type="radio"
                    label={option}
                    name="currentlyOpen"
                    id={`currentlyOpen-${option}`}
                    value={option}
                    checked={operationStatus === (option === "Yes")}
                    onChange={(e) =>
                      setOperationStatus(e.target.value === "Yes")
                    }
                  />
                ))}
              </div>
              {currentlyOpenPresent ? (
                <FieldWarning text="Please mention currently open or not" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Opening Time</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={openingHour}
                onChange={(e) => setOpeningHour(e.target.value)}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Closing Time</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                // pattern="[0-9]"
                value={closingHour}
                onChange={(e) => setClosingHour(e.target.value)}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Opened Days</strong>
            </Form.Label>
            <Col sm={9}>
              <Row>
                {daysOfWeek.map((day) => (
                  <Col key={day} xs={6} sm={4} className="mb-2">
                    <Form.Check
                      type="checkbox"
                      id={`day-${day}`}
                      label={day}
                      checked={openedDays.includes(day)}
                      onChange={() => handleCheckboxChange(day)}
                    />
                  </Col>
                ))}
              </Row>
            </Col>
          </Form.Group>

          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Outlet Category</strong>
            </Form.Label>
            <Col>
              <Form.Select
                value={outletCategory}
                onChange={(e) => setOutletCategory(e.target.value)}
                placeholder="Select Category"
              >
                {" "}
                {outCat?.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Outlet Group</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={outletGroup}
                onChange={(e) => setOutletGroup(e.target.value)}
                placeholder="Enter Outlet Group"
              />
            </Col>
          </Form.Group>
          {/* <Form.Group as={Row} sm="3">
                  <Form.Label column="true" sm="3">
                    <strong>Company Id </strong>
                  </Form.Label>
                  <Col>
                    <Form.Control
                      type="text"
                      // pattern="[0-9]"
                      value={companyId}
                      onChange={(e) => {
                        const val = e.target.value.replace(/[^0-9]/g, "");
                        setCompanyId(val);
                      }}
                      placeholder="Enter Company Id"
                    />
                    {companyIdPresent ? (
                      <FieldWarning text="Company Id should be 4 chars long" />
                    ) : (
                      ""
                    )}
                  </Col>
                </Form.Group> */}
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>
                {" "}
                Seperate GST ?<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col sm="6">
              <div className="horizontal-radio-group">
                {sepGst?.map((option) => (
                  <Form.Check
                    key={option}
                    type="radio"
                    label={option}
                    name="platRadio"
                    id={`platRadio-${option}`}
                    value={option}
                    checked={seperateGst === (option === "Yes")}
                    onChange={(e) => setSeperateGst(e.target.value === "Yes")}
                  />
                ))}
              </div>
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Added By</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                // pattern="[A-Za-z]+"
                value={addedBy}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^a-zA-Z]/g, "");
                  setAddedBy(val);
                }}
              />
            </Col>
          </Form.Group>
          <Row className="justify-content-center">
            <Col xs="auto">
              <Button variant="primary" onClick={submitHandler}>
                Submit
              </Button>
            </Col>
            <Col xs="auto">
              <Button variant="secondary" onClick={handleCancel}>
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      </Row>
    </>
  );
};

export default EditOutletScreen;
